import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Select from "react-select";
import { useSumitfeedbackMutation } from "../../Redux/service/AllEmpData";
import { GetCookie, toast } from "../../Libraries/Media";
import PropTypes from "prop-types";
import ModalComp from "../Modal";
const options = [
  { value: "Improvement", label: "Improvement" },
  { value: "Feature Request", label: "Feature Request" },
];

const SubmitFeedback = ({ openFeedBackModal, onCloseModal }) => {
  const [FeedbackSubmit] = useSumitfeedbackMutation();
  const [data, setdata] = useState({
    selectedtype: [],
    comments: "",
  });

  async function sendFeedback() {
    if (
      data.selectedtype === null ||
      data.selectedtype === undefined ||
      data.selectedtype === "null" ||
      data.selectedtype === "undefined" ||
      data.selectedtype === "" ||
      !data.selectedtype.length
    ) {
      toast.error("Please select feedback type");
    } else if (data.comments === "") {
      toast.error("Please add feedback");
    } else {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", GetCookie("es_token"));
      payload.append("txt_feedback_type", data.selectedtype);
      payload.append("txt_feedback_desc", data.comments);
      try {
        const result = await FeedbackSubmit(payload).unwrap();
        if (result.status === "true" && result.connection === "true") {
          toast.success(result.message);
          setdata({ selectedtype: [], comments: "" });
          onCloseModal();
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        toast.error(error.message);
        setdata({ selectedtype: [], comments: "" });
        onCloseModal();
      }
    }
  }
  const FeedbackBody = () => {
    return (
      <>
        <Box className="feedbackheader">
          <Box display={"flex"} justifyContent={"space-between"}>
            <span style={{ color: "#1776EE", fontWeight: "bold" }}>
              Feedback
            </span>
            <span style={{ cursor: "pointer" }} onClick={onCloseModal}>
              <CancelIcon />
            </span>
          </Box>
        </Box>

        <Box className="feedbackinputfieldbox" mt={3}>
          <label
            style={{
              marginBottom: "10px",
            }}
          >
            Feedback Type
          </label>
          <Select
            className="basic-single"
            classNamePrefix="select"
            isSearchable={true}
            name="color"
            options={options}
            onChange={(e) => setdata({ ...data, selectedtype: e.value })}
          />
          <label style={{ marginTop: "16px", marginBottom: "10px" }}>
            Type your feedback
          </label>
          <textarea
            rows={5}
            onChange={(e) => setdata({ ...data, comments: e.target.value })}
            placeholder="Type here..."
            className="feedbacktextarea"
            style={{ height: "auto" }}
          />
        </Box>
        <Box
          className="feedbacksubmitbutton"
          display={"flex"}
          justifyContent={"end"}
          mt={2}
        >
          <Button variant="contained" onClick={sendFeedback} className="capitalized fs-14 fw-bold">
            Submit
          </Button>
        </Box>
      </>
    );
  };
  return (
    <div>
      <ModalComp open={openFeedBackModal} onCloseModal={onCloseModal}>
        {FeedbackBody()}
      </ModalComp>
    </div>
  );
};

SubmitFeedback.propTypes = {
  openFeedBackModal: PropTypes.bool,
  onCloseModal: PropTypes.func,
};
export default SubmitFeedback;
